var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sign-in-page"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmitted.apply(null, arguments)}}},[_c('SignIn',{ref:"signInFormRef",staticClass:"c-max-w"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }